import React from 'react';
import 'antd/dist/antd.css';
import { Table, Tag, Card, Form, Select, Radio, Space, Tooltip, Button, Descriptions } from 'antd';
import { useState, useEffect } from 'react'
import { fetchGenevaActionHistory, fetchGenevaActionAlerts, fetchAlert } from '@utils/helpers';
import { useMsal } from '@azure/msal-react';
import { useHistory, useParams } from 'react-router';
import StackedBar from '@components/StackedBar';
import LineChart from '@components/LineChart';
import parse from 'html-react-parser';
import moment from 'moment';
import { Badge, Dropdown } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { DownOutlined } from '@ant-design/icons';
import type { TableColumnsType } from 'antd';
import { FetchFeatureSLIAlerts } from './featureSLIUtilities';
import { AlertState } from '@constants/Enums';


const items = [
  { key: '1', label: 'Action 1' },
  { key: '2', label: 'Action 2' },
];

function getWindowWidth() {
  const { innerWidth: width, innerHeight: height } = window;
  return width;
}

const isEllipsis = (getWindowWidth() <= 1280) ? true : false;

type IdParams = {
  id: string;
}

interface DataType {
  key: React.Key;
  featureName: string;
  description: string;
  schedule: string;
  status: string;  
  alertLink: string;
  alertName: string;
  lastRunState: string;
  kustoCluster: Array<any>;
  kustoTable: string;
  metrics:  Array<string>
}

interface ExpandedDataType {
  key: React.Key;
  healthMetric: string;
  name: string;
  upgradeNum: string;
}

const expandedData = [
  {
    key: 0,
    healthMetric: 'Availabilty',
    name: 'This is production name',
    upgradeNum: 'Upgraded: 56',
    executionLog: [
      { "timestamp": "16:20", "state": "Succeess" },
      { "timestamp": "16:25", "state": "Failed" },
      { "timestamp": "16:30", "state": "Success" },
      { "timestamp": "16:35", "state": "Success" },
      { "timestamp": "16:40", "state": "Failed" },
      { "timestamp": "16:45", "state": "Success" }
    ]
  },
  {
    key: 1,
    healthMetric: 'Latency',
    name: 'This is production name',
    upgradeNum: 'Upgraded: 56',
    executionLog: [
      { "timestamp": "16:20", "state": "Succeess" },
      { "timestamp": "16:25", "state": "Failed" },
      { "timestamp": "16:30", "state": "Success" },
      { "timestamp": "16:35", "state": "Success" },
      { "timestamp": "16:40", "state": "Success" },
      { "timestamp": "16:45", "state": "Success" }
    ]
  },
  {
    key: 2,
    healthMetric: 'HealthMetric3',
    name: 'This is production name',
    upgradeNum: 'Upgraded: 56',
    executionLog: [
      { "timestamp": "16:20", "state": "Succeess" },
      { "timestamp": "16:25", "state": "Failed" },
      { "timestamp": "16:30", "state": "Success" },
      { "timestamp": "16:35", "state": "Success" },
      { "timestamp": "16:40", "state": "Failed" },
      { "timestamp": "16:45", "state": "Success" }
    ]
  }
]
const expandedRowRender = (record) => {
  // const columns: TableColumnsType<ExpandedDataType> = [
  //   { title: 'HealthMetrics', dataIndex: 'healthMetric', key: 'healthMetric' },
  //   // { title: 'Name', dataIndex: 'name', key: 'name' },
  //   // {
  //   //   title: 'Status',
  //   //   key: 'state',
  //   //   render: () => <Badge status="success" text="Finished" />,
  //   // },
  //   // { title: 'Upgrade Status', dataIndex: 'upgradeNum', key: 'upgradeNum' },
  //   // {
  //   //   title: 'Action',
  //   //   dataIndex: 'operation',
  //   //   key: 'operation',
  //   //   render: () => (
  //   //     <Space size="middle">
  //   //       <a>Pause</a>
  //   //       <a>Stop</a>
  //   //     </Space>
  //   //   ),
  //   // },   
  //   ...expandedData[0].executionLog.map((log, index) => ({
  //     title: log.timestamp,
  //     dataIndex: ['executionLog', index, 'state'],
  //     key: log.timestamp,
  //     render: (state: string) => {
  //       let color = 'green';
  //       if (state === 'Failed') {
  //         color = 'red';
  //       } else if (state === 'Success') {
  //         color = 'green';
  //       }
  //       return <Tag color={color}>{state}</Tag>;
  //     },
  //   })),
  // ];


  // return <Table columns={columns} dataSource={expandedData} pagination={false} size="small" />;
  return <Descriptions style={{padding: "0 20px"}} size='small' labelStyle={{
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: 500,
    textAlign: "left",
    background: "#fafafa",
    transition: "background 0.3s ease"}}>
    <Descriptions.Item label="FeatureDescription">{record.description}</Descriptions.Item>
    {/* <Descriptions.Item label="Schedule">{record.schedule}</Descriptions.Item>
    <Descriptions.Item label="State">
      <Tag color={stateToColorMap[record.status]}>{record.status}</Tag>
    </Descriptions.Item>
    <Descriptions.Item label="Kusto Table">{record.kustoTable}</Descriptions.Item> */}
    <Descriptions.Item label="Metrics" span={3}>
      {record.metrics.map((metric, index) => {
        return <Tag key={index} color="blue">{metric}</Tag>
      })}
    </Descriptions.Item>
    <Descriptions.Item label="SLO Alerts" span={3}>
      <span style={{color: "rgba(0, 0, 0, 0.25)"}}>All alerts based on this feature SLI will be displayed here.</span>
    </Descriptions.Item>
  </Descriptions>
};


const stateToColorMap = {
  "Success": "green",
  "PartiallySuccessful": "orange",
  "Failed": "red"
}

const SLIColumns: TableColumnsType<DataType> = [
  { title: 'FeatureName', dataIndex: 'featureName', key: 'featureName', width: 150 },
  {
    title: 'State',
    key: 'state',
    dataIndex: 'status',
    width: 100,
    render: (alertState: AlertState) => {
      switch (alertState) {
        case AlertState.Active: {
          return (<Tag color={"green"} >Active</Tag>)
        }
        case AlertState.PendingCreation: {
          return (<Tag title="Pending Creation" color={"gold"} ><a style={{ color: 'gold' }} target="_blank" rel="noopener noreferrer">Pending PR Approval</a></Tag>)
        }
        case AlertState.PendingDelete: {
          return (<Tag title="Pending Delete" color={"red"} ><a style={{ color: 'red' }} target="_blank" rel="noopener noreferrer">Pending PR Approval</a></Tag>)
        }
        case AlertState.PendingUpdate: {
          return (<Tag title="Pending Update" color={"orange"} ><a style={{ color: 'orange' }} target="_blank" rel="noopener noreferrer">Pending PR Approval</a></Tag>)
        }
        case AlertState.Disabled: {
          return (<Tag color={"magenta"}>Disabled</Tag>)
        }
      }
    }
  },
  // {
  //   title: 'LastRunStatus',
  //   key: 'lastRunState',
  //   render: (record) => <Badge color={stateToColorMap[record.lastRunState]} text={record.lastRunState} />,
  // },
  // {
  //   title: 'NextRun',
  //   key: 'nextRun',
  //   render: () => <span>20 March 2024, 16:40:00</span>,
  // },
  {
    title: 'Schedule',
    key: 'schedule',
    dataIndex: 'schedule',
    width: 150,
    // render: () => <span>Every 5 minutes</span>,
  },

  //{ title: 'CreatedBy', dataIndex: 'creator', key: 'creator', render: (text) => <span>{text}</span>},
  { title: 'AlertLink', key: 'operation', render: (alertLink, record) => <a href={`/alert/${record.alertLink}`} target="_blank" rel="noopener noreferrer">{record.alertName}</a> },
  {
    title: 'KustoTable',
    key: 'kustoTable',
    render: (_, record) => {
      return record.kustoCluster.map((cluster, index) => {
        return <span>{cluster}/<b>{record.kustoTable}</b></span>
      })
    },
  },
  { title: 'Action', key: 'action', render: () => <Button disabled type="link"><a>Re-run <Tooltip title="This will re-run all the failed execution of health metrics"><QuestionCircleOutlined /></Tooltip></a></Button> }
];

const data = [
  {
    key: 0,
    featureName: 'DataRole',
    platform: 'iOS',
    upgradeNum: 500,
    lastRunState: "PartiallySuccessful",
    creator: 'gengyangchen',
    createdAt: '2014-12-24 23:12:00',
  },
  {
    key: 1,
    featureName: 'ControlRole',
    version: '10.3.4.5654',
    upgradeNum: 500,
    lastRunState: "Success",
    creator: 'test',
    createdAt: '2014-12-24 23:12:00',
  },
  {
    key: 2,
    featureName: 'Feature xxx',
    platform: 'iOS',
    version: '10.3.4.5654',
    lastRunState: "Failed",
    upgradeNum: 500,
    creator: 'test',
    createdAt: '2014-12-24 23:12:00',
  },

]


const FeatureSLIHistory: React.FC = () => {
  let { id } = useParams<IdParams>();
  const { accounts, instance } = useMsal();
  const [alerts, setAlerts] = useState<any>([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      const SLIData = await FetchFeatureSLIAlerts("10060", accounts, instance);
      setAlerts(SLIData);
      console.log(SLIData)
    };

    fetchAlerts();
  }, [accounts, instance]);
  return (
    <div style={{ padding: "50px" }}>

      <div style={{ display: "flex", width: "100%" }} >
        <Card style={{ width: "100%", border: "red 0px solid", padding: "0px", minWidth: "480px" }}>
          <div style={{ width: "100%", float: "left", border: "red 0px solid", padding: "0px" }}>
            <Form.Item style={{ minWidth: "35%", float: "left", paddingLeft: "10px" }} label="Select Service: " rules={[{ required: true, message: "Please select an alert includes machine action." }]}>
              <Select value={"App Service(Web App)"}>
              </Select>
            </Form.Item>
          </div>
        </Card>
      </div>

      <Table
        columns={SLIColumns}
        expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0', '1', '2'] }}
        dataSource={alerts}
      />
    </div>

  )
}

export default FeatureSLIHistory;

